import { useContext } from 'react';
import { ThemeContext } from './ThemeContext';

// Show the dark shade for swatches — readable in both light and dark UI
const colorMap = {
  sage:        { swatch: '#1e3d32', label: 'Sage' },
  periwinkle:  { swatch: '#2d2f7f', label: 'Periwinkle' },
  creamyRed:   { swatch: '#7a1c1c', label: 'Red' },
  honeyYellow: { swatch: '#6a4f1b', label: 'Honey' },
};

export default function ThemePicker() {
  const { accent, setAccent, isDark, toggleDark } = useContext(ThemeContext);

  return (
    <div className="space-y-3">
      {/* Dark / Light toggle */}
      <div>
        <p className="text-xs font-bold uppercase tracking-wide text-zinc-400 mb-1.5">Mode</p>
        <button
          onClick={toggleDark}
          className="flex items-center gap-2 w-full px-3 py-1.5 rounded-lg bg-zinc-100 dark:bg-zinc-700 hover:opacity-80 transition text-sm font-semibold text-zinc-800 dark:text-zinc-100"
        >
          <span>{isDark ? '☀️' : '🌙'}</span>
          <span>{isDark ? 'Light mode' : 'Dark mode'}</span>
        </button>
      </div>

      {/* Accent color swatches */}
      <div>
        <p className="text-xs font-bold uppercase tracking-wide text-zinc-400 mb-1.5">Accent</p>
        <div className="flex gap-2.5">
          {Object.entries(colorMap).map(([key, { swatch, label }]) => (
            <button
              key={key}
              onClick={() => setAccent(key)}
              className={`w-7 h-7 rounded-full border-2 transition-transform ${
                accent === key
                  ? 'border-white scale-110 shadow-md'
                  : 'border-zinc-500 hover:scale-105'
              }`}
              style={{ backgroundColor: swatch }}
              aria-label={`Select ${label} accent`}
              title={label}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
